import {DeepPartial} from 'utility-types';

import {OverviewForm} from '../types/OverviewForm';

export const DRAFT_DEFAULT_VALUES: DeepPartial<OverviewForm> = {
  articlesScope: {
    articleScopeLimitToUpdateList: true,
    branchScope: {
      articleScopeBranchAll: true,
      option: 'all',
    },
    warehouseScope: {
      articleScopeWarehouseAll: true,
      option: 'all',
    },
    articleScopeArticleDefaultSupplier: 'ANY',
  },
  updateScope: {
    updateScopeSupplierArticleAll: true,
    updateScopeSupplierArticle: [
      'RECOMMENDED_PRICE',
      'PURCHASE_PRICE',
      'SUPPLIER_DISCOUNT_GROUP',
      'BULK_PACKAGE_QUANTITY',
      'ORDERING_NUMBER',
    ],
    updateScopeWarehouseArticleAll: true,
    updateScopeWarehouseArticle: ['RECOMMENDED_PRICE', 'NAME', 'SUPPLIER_DISCOUNT_GROUP'],
  },
};
